import { ColorTextDefault, ColorTextError, ColorCostcoBlue, ColorGray700, SizeBorderWidthMedium, ColorBorderError, CardShadow, SpaceXxs, SpaceInsetSm, ButtonsRadius, SizeBorderWidthThin, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
const SelectorRadioButtonStyles = ({
  hasError = false,
  isChecked = false
}) => ({
  box: {
    display: "inline-flex",
    flexDirection: "column",
    gap: SpaceXxs
  },
  formControl: {
    border: `${hasError ? SizeBorderWidthMedium : SizeBorderWidthThin} solid ${hasError ? ColorBorderError : ColorGray700}`,
    borderRadius: ButtonsRadius,
    display: "flex",
    alignItems: "start",
    flexDirection: "row",
    padding: SpaceInsetSm,
    margin: 0,
    gap: SpaceXxs,
    "&:hover": {
      boxShadow: isChecked ? "none" : CardShadow
    },
    ".MuiTypography-root": {
      alignSelf: "start",
      alignItems: "start",
      "&.MuiFormControlLabel-label": {
        width: "100%"
      }
    },
    "&:has(span.Mui-checked)": {
      border: `${SizeBorderWidthMedium} solid ${hasError ? ColorBorderError : ColorCostcoBlue}`
    }
  },
  radioButton: {
    // unchecked radio buttons are gray
    color: `${ColorGray700} !important`,
    "&.MuiButtonBase-root": {
      padding: 0
    },
    "&.Mui-checked": {
      // checked radio buttons are blue, but red if they have an error
      color: `${hasError ? ColorTextError : ColorCostcoBlue} !important`
    }
  },
  helpLink: {
    color: ColorTextDefault,
    textDecorationColor: ColorTextDefault
  }
});
const SelectorRadioContentStyles = () => ({
  box: {
    display: "flex",
    flexDirection: "column",
    color: ColorTextDefault
  },
  titleWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: SpaceXs
  },
  icon: {
    // intentionally not using design tokens for this icon size since this is a unique use case
    margin: "2px 0",
    height: "20px",
    width: "20px"
  },
  body: {
    paddingTop: SpaceXs
  }
});
const RadioMarkdownStyles = {
  div: {
    marginTop: SpaceXs,
    display: "flex",
    flexDirection: "column",
    gap: SpaceXs
  },
  "p, ul": {
    margin: 0
  },
  ul: {
    paddingLeft: "20px"
  }
};
export {
  RadioMarkdownStyles,
  SelectorRadioButtonStyles,
  SelectorRadioContentStyles
};
